import { render, staticRenderFns } from "./taskToCommu.vue?vue&type=template&id=57ff9938&scoped=true&"
import script from "./taskToCommu.vue?vue&type=script&lang=js&"
export * from "./taskToCommu.vue?vue&type=script&lang=js&"
import style0 from "./taskToCommu.vue?vue&type=style&index=0&id=57ff9938&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff9938",
  null
  
)

export default component.exports